import { config } from "config";
import { FC } from "react";
import { useSelector } from "react-redux";

import { OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon, SpacingToken } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";
import { selectCurrentAgentProperties } from "store/features/session";
import { withVar } from "themes/helpers";

import { AgentFormSection } from "./AgentFormSection";
import { AgentFormSectionId } from "./constants";

interface IProps {
  agentId: string;
}

export const Agent2FA: FC<IProps> = ({ agentId }) => {
  const is2FAEnabled = useSelector(selectCurrentAgentProperties)?.mfa;

  return (
    <AgentFormSection
      header={{ id: AgentFormSectionId.TwoFactorAuthentication, component: "Two-factor authentication (2FA)" }}
    >
      <Text fontSize="14px" marginBottom={withVar(SpacingToken.Spacing5)} lineHeight="20px">
        {is2FAEnabled
          ? "2FA is enabled for your account."
          : "2FA makes it more difficult for someone else to sign in to your account. Use an authentication app like Google authenticator to protect your account."}
      </Text>
      <Button
        icon={<Icon source={OpenInNew} />}
        iconPosition="right"
        kind="secondary"
        size="compact"
        href={`${config.textAccountsPanel}/${agentId}?modal=twofa`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {is2FAEnabled ? "Disable 2FA" : "Enable 2FA"}
      </Button>
    </AgentFormSection>
  );
};
